import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bling as GPT} from 'react-gpt';
import {getSection} from "../../../utils/commonUtils";

require("./GooglePublisherTag.scss");

export default class GooglePublisherTag extends Component {

  static propTypes = {
    isStagingEnv: PropTypes.bool.isRequired,
    adsEnabled: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['topBanner', 'topMPU', 'bottomMPU', 'singleBottomMPU']).isRequired,
    adUnitPath: PropTypes.string.isRequired,
    fullyRegistered: PropTypes.bool,
    targetParams: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    windowIsLoaded: PropTypes.bool.isRequired,
    hostname: PropTypes.string.isRequired,
    routes: PropTypes.array.isRequired,
    initializationComplete: PropTypes.bool,
    tamAvailable: PropTypes.bool,
    advertSlots: PropTypes.object
  };

  static getDerivedStateFromProps(props, state = { hadError: false, loadGpt: false, gptParams: {}}) {
    const gptParams = {
      ...props.targetParams,
      targeting: {
        ...props.targetParams.targeting,
        ...createTagTargetParams(props)
      },
      collapseEmptyDiv: true
    };

    return {...state, loadGpt: props.adsEnabled, gptParams};
  }

  constructor(props) {
    super(props);
    this.gptTag = React.createRef();
    this.state = {};
  }

  shouldComponentUpdate(nextProps) {
    if (!global.location) {
      return false;
    }
    const relevantProps = [
      [this.props.adUnitPath, nextProps.adUnitPath],
      [this.props.type, nextProps.type],
      [this.props.path, nextProps.path],
      [this.props.windowIsLoaded, nextProps.windowIsLoaded],
      [this.props.advertSlots, nextProps.advertSlots],
      [this.props.initializationComplete, nextProps.initializationComplete]
    ];

    const diff = relevantProps
      .filter(pair => pair[0] !== pair[1]);

    const propsHaveChanged = diff
      .length > 0;

    return propsHaveChanged;
  }

  componentDidCatch() {
    
    if (this.gptTag.current && this.state.hadError === false) {
      this.gptTag.current.refresh();
    }
    this.setState({...this.state, hadError: true});
  }

  render() {
    const initialized = this.props.adsEnabled &&
      this.props.windowIsLoaded &&
      this.props.initializationComplete;

    const slotId = this.props.adUnitPath;
    const renderSlot = true;

    const gptComponent = <GPT id={slotId} ref={this.gptTag} adUnitPath={this.props.adUnitPath} {...this.state.gptParams} />

    if (initialized && this.props.tamAvailable && !this.props.advertSlots[slotId]){
      const slotSize = this.state.gptParams.slotSize;
      const sizeMapping = this.state.gptParams.sizeMapping;
      this.props.fetchAdverts(slotId, slotSize, sizeMapping);
    }

    return (
      <div className="gpt-container" data-type={this.props.type}>
        { initialized && renderSlot && gptComponent }
      </div>
    );
  }
}

function getTagTestParams(queryParams) {
  let props = {};
  if (queryParams.Display_KW_Test && /^[a-z_0-9]+$/i.test(queryParams.Display_KW_Test)) {
    props = {...props, Display_KW_Test: [queryParams.Display_KW_Test]};
  }
  if (queryParams.app) {
    props = {...props, Display_SL_App_Type: [queryParams.app]}
  }
  return props;
}

function createTagTargetParams(props) {

  let params = props.location.query ? 
    {...getTagTestParams(props.location.query)} :
    {};
  
  if (props.isStagingEnv) {
    params.Display_SL_Staging = props.isStagingEnv;
  }
  
  if (props.location.pathname) {
    params.Display_SL_Pathname = [props.location.pathname];
  }

  if (props.hostname) {
    //lower case attribute name is correct here
    params.display_sl_hostname = [props.hostname];
  }

  if (props.fullyRegistered !== null) {
    params.Display_SL_Reg = props.fullyRegistered ? "full" : "part";
  }

  params.display_sl_section = getSection(props.routes);
  return {...params};
}



// WEBPACK FOOTER //
// ./modules/Common/components/GooglePublisherTag.js